import { render, staticRenderFns } from "./CapturaDocumentoFrente.vue?vue&type=template&id=12112a6b&scoped=true&"
import script from "./CapturaDocumentoFrente.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoFrente.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoFrente.vue?vue&type=style&index=0&id=12112a6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12112a6b",
  null
  
)

export default component.exports